import type {CheckoutBrand} from '@wix/ambassador-ecom-v1-ecommerce-settings/types';
import type {LoadingStateEcommerceSettings} from '@wix/ecom-platform-viewer-script';

export enum MessageSource {
  Composer = 'checkout-composer',
  Viewer = 'checkout-viewer',
}

export enum MessageType {
  DesignChange = 'designChange',
  SettingsChange = 'settingsChange',
  Ready = 'ready',
}

export type DesignChangeMessage = {
  source: MessageSource.Composer;
  type: MessageType.DesignChange;
  payload: {brand?: CheckoutBrand};
};

export type SettingsChangeMessage = {
  source: MessageSource.Composer;
  type: MessageType.SettingsChange;
  payload: {checkoutSettings?: LoadingStateEcommerceSettings['checkoutSettings']};
};

export type ReadyMessage = {
  source: MessageSource.Viewer;
  type: MessageType.Ready;
};
